import { css } from '@emotion/css'
import { accessiblyHidden } from '../../utils/styleUtils'
import { shorthandHelper } from '../../styles/helpers'
import { colors } from '../../themes'
import { lineHeight, fontFamily, fontSize, fontWeight, spacing } from '../../styles'

const styles = {
  fieldset: css({
    border: 'none',
    padding: 0,
    margin: 0,
  }),

  legend: css({
    padding: 0,
    margin: shorthandHelper([0, 0, spacing.default]),
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    fontWeight: fontWeight.regular,
    lineHeight: lineHeight.default,
    color: colors.blackPearl,
  }),

  hideLegend: css(accessiblyHidden),
}

export default styles
